import { Autocomplete, TextField } from '@mui/material';
import type { AutocompleteProps } from '@mui/material/Autocomplete';
import { CRITERION_OPERATORS } from '@vy/types';
import { values } from '@vy/utils';
import React from 'react';

type CriterionSelectProps = Omit<
  AutocompleteProps<string, false, false, false>,
  'options' | 'renderInput'
> & {
  inputRef?: React.Ref<HTMLInputElement>;
};

export const CriterionSelect: React.FC<CriterionSelectProps> = ({ inputRef, ...props }) => {
  return (
    <Autocomplete
      size="small"
      {...props}
      options={values(CRITERION_OPERATORS)}
      renderInput={(params) => (
        <TextField
          label="Criterion"
          placeholder="Select criterion"
          {...params}
          inputRef={inputRef}
          slotProps={{
            ...params.slotProps,

            htmlInput: {
              ...params.slotProps.htmlInput,
              autoComplete: 'new-password',
            },

            inputLabel: { shrink: true }
          }} />
      )}
    />
  );
};
